module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-96x96.4c25ba39000113b2053e2412e15f4309.png";